import { render, staticRenderFns } from "./grid_xy.vue?vue&type=template&id=d280dad2&scoped=true&lang=pug&"
import script from "./grid_xy.vue?vue&type=script&lang=js&"
export * from "./grid_xy.vue?vue&type=script&lang=js&"
import style0 from "./grid_xy.vue?vue&type=style&index=0&id=d280dad2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d280dad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d280dad2', component.options)
    } else {
      api.reload('d280dad2', component.options)
    }
    module.hot.accept("./grid_xy.vue?vue&type=template&id=d280dad2&scoped=true&lang=pug&", function () {
      api.rerender('d280dad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/box_layout/grid_xy.vue"
export default component.exports